import { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimalTypeEnum } from '@api/types/AnimalTypeEnum';
import PriceInfo from '@pages/order-cat/price-info/PriceInfo';
import AnimalInfo from '@pages/order-cat/animal-info/AnimalInfo';
import SurgeryInfo from '@pages/order-cat/surgery-info/SurgeryInfo';
import Patterns from '@pages/order/patterns/Patterns';
import CustomerInfo from '@pages/order/customer-info/CustomerInfo';
import CustomerAddress from '@pages/order/customer-address/CustomerAddress';
import PaymentShipping from '@pages/order/payment-shipping/PaymentShipping';
import MessageDiscount from '@pages/order/message-discount/MessageDiscount';
import Footer from '@pages/order-cat/footer/Footer';



interface OrderCatFormProps {
	goToSummary: () => void,
}


const OrderCatForm = (props: OrderCatFormProps) => {
	const { goToSummary } = props;
	const { t } = useTranslation('forms');

	const formRef = useRef<HTMLDivElement>(null);

	
	const scrollToTop = useCallback(() => {
		formRef?.current?.scrollIntoView({ behavior: 'smooth' });
	},[ formRef ]);

	
	return (
		<div className='order-form cat-order-form' ref={formRef}>

			<h1>{t('cats.header')}</h1>

			<div className='intro-text'>
				<p>{t('cats.introText')}</p>
			</div>

			<PriceInfo />

			<h2>{t('cats.title')}</h2>

			<AnimalInfo />

			<SurgeryInfo />

			<Patterns animalType={AnimalTypeEnum.cat} />

			<CustomerInfo />

			<CustomerAddress />

			<PaymentShipping />

			<MessageDiscount />

			<Footer scrollToTop={scrollToTop} goToSummary={goToSummary} />

		</div>
	);
};

export default OrderCatForm;